import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-image-overlay',
  templateUrl: './card-image-overlay.component.html',
  styleUrls: ['./card-image-overlay.component.css']
})
export class CardImageOverlayComponent implements OnInit {

  @Input() cardInfo;
  
  constructor() { }

  ngOnInit(): void {
  }

}
